import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useIsPeerReviewEnabled } from "@components/QaReview/hooks/useIsPeerReviewEnabled";
import { useMyAuth0Id } from "@components/ReportReview/hooks/useMyAuth0Id";
import { useReportReviewers } from "@components/ReportReview/hooks/useReportReviewers";
import { useReport } from "@providers/ReportProvider";

export const WAITING_ON_YOU = "Waiting on you";
export const SENT_BACK_TO_YOU = "Sent back to you";

type Chip = { label: string; tone: "pending" | "sentBack" };

export const useReviewChip = (): Chip | null => {
  const { report } = useReport();
  const { reviewers } = useReportReviewers();
  const myId = useMyAuth0Id();
  const isPeerReviewEnabled = useIsPeerReviewEnabled();

  if (!isPeerReviewEnabled || !myId) return null;
  const mine = reviewers.find(({ reviewer }) => reviewer?.id === myId);
  if (mine?.status === ReportReviewerStatus.Requested) return { label: WAITING_ON_YOU, tone: "pending" };
  // Withdrawn reviewers are already filtered out; the author's own reviewer row never sends the report back to them.
  const sentBack = reviewers.some(
    ({ status, reviewer }) => status === ReportReviewerStatus.ChangesRequested && reviewer?.id !== myId,
  );
  if (report.createdBy?.id === myId && sentBack) return { label: SENT_BACK_TO_YOU, tone: "sentBack" };
  return null;
};
